import { SECTION_IDS } from '../const';
import { CREATE_BREAKDOWN_FLOW_TEXT } from '../texts';
import { deriveCommonRows } from './deriveCommonRows';
import { deriveCushioningRows } from './deriveCushioningRows';
import { deriveDeadheadInfoRows } from './deriveDeadheadInfoRows';
import { deriveParallelRideRows } from './deriveParallelRideRows';
import { derivePostIncidentDrivingRows } from './derivePostIncidentDrivingRows';
import { deriveReplacementDriverInfoRows } from './deriveReplacementDriverInfoRows';

/**
 * @typedef {object} SummaryRow
 * @property {string} label Left-column label.
 * @property {string} value Right-column formatted value.
 * @property {import('react').ComponentType} icon Leading icon component from `@flixbus/honeycomb-icons-react`.
 */

/**
 * @typedef {object} SummarySection
 * @property {string} id Stable id — matches the ids listed in `breakdownFlowConfig.nodes[*].summarySections`.
 * @property {string} title Accordion title.
 * @property {boolean} defaultOpen Whether the accordion is expanded on Summary open.
 * @property {(data: object) => SummaryRow[]} buildRows Pure derivation over `data`.
 */

const TITLES = CREATE_BREAKDOWN_FLOW_TEXT.summary.sectionTitles;

/**
 * Section registry. Every entry is looked up by id from the flow config's
 * per-node `summarySections` array. Each `buildRows` is a pure function unit-
 * tested in isolation; the Summary component only iterates + renders.
 *
 * @type {Record<string, SummarySection>}
 */
export const SUMMARY_SECTIONS = {
	[SECTION_IDS.common]: {
		id: SECTION_IDS.common,
		title: TITLES.common,
		defaultOpen: true,
		buildRows: deriveCommonRows,
	},
	[SECTION_IDS.deadheadInfo]: {
		id: SECTION_IDS.deadheadInfo,
		title: TITLES.deadheadInfo,
		defaultOpen: false,
		buildRows: deriveDeadheadInfoRows,
	},
	[SECTION_IDS.replacementDriverInfo]: {
		id: SECTION_IDS.replacementDriverInfo,
		title: TITLES.replacementDriverInfo,
		defaultOpen: false,
		buildRows: deriveReplacementDriverInfoRows,
	},
	[SECTION_IDS.postIncidentDriving]: {
		id: SECTION_IDS.postIncidentDriving,
		title: TITLES.postIncidentDriving,
		defaultOpen: false,
		buildRows: derivePostIncidentDrivingRows,
	},
	[SECTION_IDS.cushioningParameters]: {
		id: SECTION_IDS.cushioningParameters,
		title: TITLES.cushioningParameters,
		defaultOpen: false,
		buildRows: deriveCushioningRows,
	},
	[SECTION_IDS.parallelRide]: {
		id: SECTION_IDS.parallelRide,
		title: TITLES.parallelRide,
		defaultOpen: false,
		buildRows: deriveParallelRideRows,
	},
};
